import {
  //
  ADD_RESIDENT,
  ADD_RESIDENT_FAILURE,
  ADD_RESIDENT_SUCCESS,
  //
  DELETE_RESIDENT,
  DELETE_RESIDENT_FAILURE,
  DELETE_RESIDENT_SUCCESS,
  //
  EDIT_RESIDENT,
  EDIT_RESIDENT_FAILURE,
  EDIT_RESIDENT_SUCCESS,
  //
  FETCH_RESIDENT,
  FETCH_RESIDENT_FAILURE,
  FETCH_RESIDENT_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  TOGGLE_BELONGINGS_MODAL,
  TOGGLE_RESIDENT_MODAL,
  //
  UPDATE_PROFILE,
  UPDATE_PROFILE_FAILURE,
  UPDATE_PROFILE_SUCCESS,

  // Belongings
  FETCH_BELONGINGS,
  FETCH_BELONGINGS_FAILURE,
  FETCH_BELONGINGS_SUCCESS,
  //
  ADD_BELONGING,
  ADD_BELONGING_FAILURE,
  ADD_BELONGING_SUCCESS,
  //
  DELETE_BELONGING,
  DELETE_BELONGING_FAILURE,
  DELETE_BELONGING_SUCCESS,
  //
  GET_RESIDENT_DATA,
  GET_RESIDENT_DATA_FAILURE,
  GET_RESIDENT_DATA_SUCCESS,
  //
  GET_DOC_STATUS,
  GET_DOC_STATUS_FAILURE,
  GET_DOC_STATUS_SUCCESS,
  //
  GET_TIMELINE,
  GET_TIMELINE_FAILURE,
  GET_TIMELINE_SUCCESS,
  //
  LOAD_MORE_TIMELINE,
  LOAD_MORE_TIMELINE_FAILURE,
  LOAD_MORE_TIMELINE_SUCCESS,
  //
  GET_MY_ASSESSMENTS,
  GET_MY_ASSESSMENTS_FAILURE,
  GET_MY_ASSESSMENTS_SUCCESS,
  //
  GET_OVERVIEW,
  GET_OVERVIEW_FAILURE,
  GET_OVERVIEW_SUCCESS,
  //
  CONVERT_RESIDENT,
  CONVERT_RESIDENT_FAILURE,
  CONVERT_RESIDENT_SUCCESS,
  //
  UPDATE_RESIDENT_STATUS,
  UPDATE_RESIDENT_STATUS_FAILURE,
  UPDATE_RESIDENT_STATUS_SUCCESS,
  //
  GET_TIMELINE_INFO,
  GET_TIMELINE_INFO_FAILURE,
  GET_TIMELINE_INFO_SUCCESS,
  //
  GET_PRE_ASSESSMENT,
  GET_PRE_ASSESSMENT_FAILURE,
  GET_PRE_ASSESSMENT_SUCCESS,
  //
  GET_ASSESSMENT_FORM,
  GET_ASSESSMENT_FORM_FAILURE,
  GET_ASSESSMENT_FORM_SUCCESS,
  //
  GET_DOC_QR_CODE,
  GET_DOC_QR_CODE_FAILURE,
  GET_DOC_QR_CODE_SUCCESS,
  //
  ADD_PRE_ASSESSMENT,
  ADD_PRE_ASSESSMENT_FAILURE,
  ADD_PRE_ASSESSMENT_SUCCESS,
  //
  EDIT_PRE_ASSESSMENT,
  EDIT_PRE_ASSESSMENT_FAILURE,
  EDIT_PRE_ASSESSMENT_SUCCESS,
} from "./constants";

// List
export const fetchResidents = (payload) => ({
  type: FETCH_RESIDENT,
  payload,
});
export const fetchResidentSuccess = (payload) => ({
  type: FETCH_RESIDENT_SUCCESS,
  payload,
});
export const fetchResidentFailure = (payload) => ({
  type: FETCH_RESIDENT_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addResident = (payload, onAdd) => ({
  type: ADD_RESIDENT,
  payload,
  onAdd,
});
export const addResidentSuccess = (payload) => ({
  type: ADD_RESIDENT_SUCCESS,
  payload,
});
export const addResidentFailure = (payload) => ({
  type: ADD_RESIDENT_FAILURE,
  payload,
});
// EDIT
export const editResident = (payload, onEdit) => ({
  type: EDIT_RESIDENT,
  payload,
  onEdit,
});
export const editResidentSuccess = (payload) => ({
  type: EDIT_RESIDENT_SUCCESS,
  payload,
});
export const editResidentFailure = (payload) => ({
  type: EDIT_RESIDENT_FAILURE,
  payload,
});
// DELETE
export const deleteResident = (payload, onDelete) => ({
  type: DELETE_RESIDENT,
  payload,
  onDelete,
});
export const deleteResidentSuccess = (payload) => ({
  type: DELETE_RESIDENT_SUCCESS,
  payload,
});
export const deleteResidentFailure = (payload) => ({
  type: DELETE_RESIDENT_FAILURE,
  payload,
});

// Modal
export const toggleResidentModal = (payload) => ({
  type: TOGGLE_RESIDENT_MODAL,
  payload,
});

// Update Profile
export const updateProfile = (payload, onUpdate) => ({
  type: UPDATE_PROFILE,
  payload,
  onUpdate,
});
export const updateProfileSuccess = (payload) => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload,
});
export const updateProfileFailure = (payload) => ({
  type: UPDATE_PROFILE_FAILURE,
  payload,
});

// Belongings Modal
export const toggleBelongingsModal = (payload) => ({
  type: TOGGLE_BELONGINGS_MODAL,
  payload,
});

// Belongings
export const fetchBelongings = (payload) => ({
  type: FETCH_BELONGINGS,
  payload,
});

export const fetchBelongingsSuccess = (payload) => ({
  type: FETCH_BELONGINGS_SUCCESS,
  payload,
});
export const fetchBelongingsFailure = (payload) => ({
  type: FETCH_BELONGINGS_FAILURE,
  payload,
});

export const addBelonging = (payload, onAdd) => ({
  type: ADD_BELONGING,
  payload,
  onAdd,
});
export const addBelongingSuccess = (payload) => ({
  type: ADD_BELONGING_SUCCESS,
  payload,
});
export const addBelongingFailure = (payload) => ({
  type: ADD_BELONGING_FAILURE,
  payload,
});

export const deleteBelonging = (payload, onDelete) => ({
  type: DELETE_BELONGING,
  payload,
  onDelete,
});
export const deleteBelongingSuccess = (payload) => ({
  type: DELETE_BELONGING_SUCCESS,
  payload,
});
export const deleteBelongingFailure = (payload) => ({
  type: DELETE_BELONGING_FAILURE,
  payload,
});

// Get Resident Data
export const getResidentData = (payload) => ({
  type: GET_RESIDENT_DATA,
  payload,
});
export const getResidentDataSuccess = (payload) => ({
  type: GET_RESIDENT_DATA_SUCCESS,
  payload,
});
export const getResidentDataFailure = (payload) => ({
  type: GET_RESIDENT_DATA_FAILURE,
  payload,
});

// Get Doc Status
export const getDocStatus = (payload, onDocStatus) => ({
  type: GET_DOC_STATUS,
  payload,
  onDocStatus,
});
export const getDocStatusSuccess = (payload) => ({
  type: GET_DOC_STATUS_SUCCESS,
  payload,
});
export const getDocStatusFailure = (payload) => ({
  type: GET_DOC_STATUS_FAILURE,
  payload,
});

// Get Timeline
export const getTimeline = (payload) => ({
  type: GET_TIMELINE,
  payload,
});
export const getTimelineSuccess = (payload) => ({
  type: GET_TIMELINE_SUCCESS,
  payload,
});
export const getTimelineFailure = (payload) => ({
  type: GET_TIMELINE_FAILURE,
  payload,
});

// Load More Timeline (for infinite scroll)
export const loadMoreTimeline = (payload) => ({
  type: LOAD_MORE_TIMELINE,
  payload,
});
export const loadMoreTimelineSuccess = (payload) => ({
  type: LOAD_MORE_TIMELINE_SUCCESS,
  payload,
});
export const loadMoreTimelineFailure = (payload) => ({
  type: LOAD_MORE_TIMELINE_FAILURE,
  payload,
});

// Get My Assessments
export const getMyAssessments = (payload, onGet) => ({
  type: GET_MY_ASSESSMENTS,
  payload,
  onGet,
});
export const getMyAssessmentsSuccess = (payload) => ({
  type: GET_MY_ASSESSMENTS_SUCCESS,
  payload,
});
export const getMyAssessmentsFailure = (payload) => ({
  type: GET_MY_ASSESSMENTS_FAILURE,
  payload,
});

// Get Overview
export const getOverview = (payload) => ({
  type: GET_OVERVIEW,
  payload,
});
export const getOverviewSuccess = (payload) => ({
  type: GET_OVERVIEW_SUCCESS,
  payload,
});
export const getOverviewFailure = (payload) => ({
  type: GET_OVERVIEW_FAILURE,
  payload,
});

// Convert Resident
export const convertResident = (payload, onConvert) => ({
  type: CONVERT_RESIDENT,
  payload,
  onConvert,
});
export const convertResidentSuccess = (payload) => ({
  type: CONVERT_RESIDENT_SUCCESS,
  payload,
});
export const convertResidentFailure = (payload) => ({
  type: CONVERT_RESIDENT_FAILURE,
  payload,
});

// Update Resident Status
export const updateResidentStatus = (payload, onUpdate) => ({
  type: UPDATE_RESIDENT_STATUS,
  payload,
  onUpdate,
});
export const updateResidentStatusSuccess = (payload) => ({
  type: UPDATE_RESIDENT_STATUS_SUCCESS,
  payload,
});
export const updateResidentStatusFailure = (payload) => ({
  type: UPDATE_RESIDENT_STATUS_FAILURE,
  payload,
});

// Get Timeline Info
export const getTimelineInfo = (payload, onGet) => ({
  type: GET_TIMELINE_INFO,
  payload,
  onGet,
});
export const getTimelineInfoSuccess = (payload) => ({
  type: GET_TIMELINE_INFO_SUCCESS,
  payload,
});
export const getTimelineInfoFailure = (payload) => ({
  type: GET_TIMELINE_INFO_FAILURE,
  payload,
});

// Get Pre Assessment
export const getPreAssessment = (payload, onGet) => ({
  type: GET_PRE_ASSESSMENT,
  payload,
  onGet,
});
export const getPreAssessmentSuccess = (payload) => ({
  type: GET_PRE_ASSESSMENT_SUCCESS,
  payload,
});
export const getPreAssessmentFailure = (payload) => ({
  type: GET_PRE_ASSESSMENT_FAILURE,
  payload,
});

// Get Assessment Form
export const getAssessmentForm = (payload, onGet) => ({
  type: GET_ASSESSMENT_FORM,
  payload,
  onGet,
});
export const getAssessmentFormSuccess = (payload) => ({
  type: GET_ASSESSMENT_FORM_SUCCESS,
  payload,
});
export const getAssessmentFormFailure = (payload) => ({
  type: GET_ASSESSMENT_FORM_FAILURE,
  payload,
});

// Get Doc QR Code
export const getDocQRCode = (payload, onGet) => ({
  type: GET_DOC_QR_CODE,
  payload,
  onGet,
});
export const getDocQRCodeSuccess = (payload) => ({
  type: GET_DOC_QR_CODE_SUCCESS,
  payload,
});
export const getDocQRCodeFailure = (payload) => ({
  type: GET_DOC_QR_CODE_FAILURE,
  payload,
});

// Add Pre Assessment
export const addPreAssessment = (payload, onAdd) => ({
  type: ADD_PRE_ASSESSMENT,
  payload,
  onAdd,
});
export const addPreAssessmentSuccess = (payload) => ({
  type: ADD_PRE_ASSESSMENT_SUCCESS,
  payload,
});
export const addPreAssessmentFailure = (payload) => ({
  type: ADD_PRE_ASSESSMENT_FAILURE,
  payload,
});

export const editPreAssessment = (payload, onEdit) => ({
  type: EDIT_PRE_ASSESSMENT,
  payload,
  onEdit,
});
export const editPreAssessmentSuccess = (payload) => ({
  type: EDIT_PRE_ASSESSMENT_SUCCESS,
  payload,
});
export const editPreAssessmentFailure = (payload) => ({
  type: EDIT_PRE_ASSESSMENT_FAILURE,
  payload,
});
